var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":"https://img1.clozhome.com/new-clozhome/mini/app_page_assets/logo.png"}})])
}]

export { render, staticRenderFns }